<template>
  <b-modal id="bv-modal-remove-checkin" size="sm" hide-header centered @ok="removeCheckin" @show="showModal"
           @hidden="resetModal">
    <div class="text-center">
      <Icon name="grTrash" width="36" class="mb-3"/>
      <h1 class="modal-title mb-2">
        <template v-if="errorMessage">
          {{ $t('modal_remove_checkin.attention_title') }}
        </template>
        <template v-else>
          {{ $t('modal_remove_checkin.title') }}
        </template>
      </h1>
      <template v-if="errorMessage">
        <h4 class="modal-subtitle error mb-3" v-html="errorMessage"></h4>
      </template>
      <template v-else-if="canRemove">
        <h4 class="modal-subtitle mb-4">{{ $t('modal_remove_checkin.subtitle') }}</h4>
        <h4 class="h5 code">{{ picacode }}</h4>
      </template>
      <template v-else>
        <h4 class="modal-subtitle">{{ $t('modal_remove_checkin.attention_title') }}</h4>
        <h4 class="modal-subtitle mb-3">{{ $t('modal_remove_checkin.attention_text') }}</h4>
      </template>
    </div>
    <template #modal-footer="{ ok, cancel }">
      <div class="w-100">
        <div class="d-sm-flex justify-content-center">
          <div class="flex-grow-1 order-sm-1 mb-2  ml-sm-2 mb-sm-0" v-if="canRemove && !errorMessage">
            <b-button variant="danger" block @click="ok()">
              {{ $t('modal_remove_checkin.action_confirm') }}
            </b-button>
          </div>
          <div class="flex-grow-1  order-sm-0 mr-sm-2">
            <b-button :variant="canRemove && !errorMessage ? 'light' : 'primary'" block @click="cancel()">
              <template v-if="canRemove && !errorMessage">
                {{ $t('modal_remove_checkin.action_cancel') }}
              </template>
              <template v-else>
                {{$t('modal_popup.btn_ok')}}
              </template>
            </b-button>
          </div>
        </div>
      </div>
    </template>
  </b-modal>
</template>


<script>
import EventService from "@/services/Event.js"
import {mapGetters} from "vuex";
import {getContactUrl} from "@/utils";

const SUPPORT_EMAIL = 'support@getpica.com'

export default {
  props: {
    picacode: {
      type: String,
      required: true
    },
    checkinId: {
      type: Number,
      required: true
    },
    eventName: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      canRemove: true,
      digitalItemId: null,
      errorMessage: null
    }
  },
  computed: {
    ...mapGetters('appConfig', [
      'hideCart'
    ]),
    ...mapGetters('cartDigitalItems', [
      'getDigitalItemByPicaCode'
    ])
  },

  methods: {
    showModal() {
      if (!this.hideCart) {
        // verifico se nel carrello c'è un digitalItem relativo a questo picacode
        const digitalItem = this.getDigitalItemByPicaCode(this.picacode)
        if (digitalItem && digitalItem.media_ids && digitalItem.media_ids.length > 0) {
          this.digitalItemId = digitalItem.id
        }
      }

    },

    resetModal() {
      this.digitalItemId = null
      this.canRemove = true
      this.errorMessage = null
    },

    removeCheckin(bvModalEvt) {
      // tengo aperta la modale finché la richiesta non è andata a buon fine,
      // così posso mostrare l'eventuale errore al suo interno
      bvModalEvt.preventDefault()

      EventService.removeCheckin(this.checkinId).then(() => {
        this.$bvModal.hide('bv-modal-remove-checkin')
        this.$bvToast.toast(this.$tc('notifications.checkin_removed', this.picacode))
        this.$emit('checkin-removed', this.checkinId)
        this.$router.push({name: 'checkins-list'}).catch(err => {
          // Ignore the vuex err regarding navigating to the page they are already on
          if (err.name !== 'NavigationDuplicated') {
            throw err
          }
        })
      }).catch(error => {
        const detail = error.response && error.response.data && error.response.data.detail
        this.errorMessage = detail ? this.addContactSubject(detail) : this.$t('modal_remove_checkin.error_message')
      })
    },

    addContactSubject(message) {
      if (!message.includes(SUPPORT_EMAIL)) {
        return message
      }
      const subject = this.eventName ? `${this.picacode} | ${this.eventName}` : this.picacode
      const contactUrl = getContactUrl(encodeURIComponent(subject))
      if (message.includes(`mailto:${SUPPORT_EMAIL}`)) {
        // sostituisco l'href esistente (con eventuale query) mantenendo il testo del link
        return message.replace(/mailto:support@getpica\.com[^"']*/g, contactUrl)
      }
      return message.replace(new RegExp(SUPPORT_EMAIL, 'g'), `<a href="${contactUrl}">${SUPPORT_EMAIL}</a>`)
    }
  }
}
</script>

<style>
.modal-subtitle.error {
   line-height: 1.5;
 }
 .modal-subtitle.error a{
   display: block;
   text-decoration: underline;
 }
</style>

